import { isNumber } from 'lodash';
import { hasTruthyProperties } from '../helpers/object.helpers';
import { IProjectFolder } from '../models/folder.model';
import { throwValidationErrors } from './validation.helpers';
import {
  getProjectFolderPath,
  isProjectFolder,
} from '../helpers/project-folder.helpers';
import { isNumeric } from '../helpers/math.helpers';
import { OneOfProjectListElements } from '../models/project.model';
import { ValidationResult, GenericValidationError } from './validation.models';

export const validateFolder = (
  folder: IProjectFolder,
  onError?: (error: string) => void,
): IProjectFolder => {
  throwValidationErrors(
    isValidFolder(folder),
    'FolderValidationError',
    onError,
  );
  return folder;
};

export const isValidFolder = (folder: IProjectFolder): ValidationResult => {
  const { location, parent_id } = folder;
  if (!isNumber(location)) {
    return new GenericValidationError('Location must be a number');
  }
  if (!hasTruthyProperties(folder, 'id', 'name')) {
    return new GenericValidationError('Recipe elements are missing name or id');
  }
  // Only project ids are numeric
  if (parent_id && isNumeric(parent_id)) {
    return new GenericValidationError('parent_id must be a string');
  }

  return true;
};

const isValidFolderList = (
  list: OneOfProjectListElements[],
): ValidationResult => {
  const folders = list.filter(isProjectFolder);
  for (const folder of folders) {
    const isValid = isValidFolder(folder);
    if (isValid !== true) {
      return isValid;
    }
  }
  for (const folder of folders) {
    try {
      // This will crash if there is a circular reference
      getProjectFolderPath(folders, folder);
    } catch (e) {
      return new GenericValidationError((e as Error).message);
    }
  }

  return true;
};

export const validateFolderList = <T extends OneOfProjectListElements>(
  folders: T[],
): T[] => {
  throwValidationErrors(isValidFolderList(folders));
  return folders;
};
